import { APP_CONFIG } from '../Config';

export const isProduction = (): boolean => {
    const { APP_ENV = 'prod' } = APP_CONFIG;
    return APP_ENV === 'prod' || APP_ENV === 'production';
};

export const isDevelopment = (): boolean => {
    const { APP_ENV = 'prod' } = APP_CONFIG;
    return ['dev', 'development', 'local'].includes(APP_ENV);
};